import { colorsTuple, createTheme, MantineColorsTuple } from "@mantine/core";

const yellow: MantineColorsTuple = [
  "#fffbe6",
  "#fef7d5",
  "#feefa4",
  "#fee670",
  "#fedf47",
  "#feda32",
  "#fed829",
  "#e2bf1f",
  "#c9a915",
  "#ad9200",
];

const orange: MantineColorsTuple = [
  "#fff7e1",
  "#ffeecb",
  "#ffdc9a",
  "#ffc864",
  "#ffb838",
  "#ffae1b",
  "#ffa500",
  "#e39300",
  "#cb8200",
  "#b06f00",
];

const green: MantineColorsTuple = [
  "#ebfff6",
  "#d6fdec",
  "#a8fbd6",
  "#77fabf",
  "#55f9ac",
  "#43f9a0",
  "#3af999",
  "#2fdd85",
  "#22c575",
  "#039355",
];

const blue: MantineColorsTuple = [
  "#e8efff",
  "#cfdaff",
  "#9cb2ff",
  "#6687fe",
  "#3962fd",
  "#1f4bfd",
  "#0f40fe",
  "#0035f0",
  "#002ccc",
  "#0025b4",
];

const pine: MantineColorsTuple = [
  "#ebfff6",
  "#d6fdec",
  "#a8fbd6",
  "#77fac0",
  "#55f9ac",
  "#43f9a0",
  "#3af999",
  "#2fdd85",
  "#22c575",
  "#02663b",
];

const red: MantineColorsTuple = [
  "#ffede7",
  "#ffd9d1",
  "#f8b1a2",
  "#f48670",
  "#f06245",
  "#ee4b29",
  "#ee3f1b",
  "#dd3310",
  "#bd290b",
  "#a61e05",
];

const aqua: MantineColorsTuple = [
  "#e0fffd",
  "#cdfdf8",
  "#a0f9ef",
  "#6ff5e5",
  "#48f2dd",
  "#2ff0d8",
  "#1aefd6",
  "#00d4bd",
  "#00bda8",
  "#00a490",
];

const grey: MantineColorsTuple = [
  "#f5f5f5",
  "#e7e7e7",
  "#cdcdcd",
  "#b2b2b2",
  "#9a9a9a",
  "#8b8b8b",
  "#848484",
  "#717171",
  "#656565",
  "#2a2a2a",
];

export const customTheme = createTheme({
  fontFamily: "var(--text-font-sans)",
  black: "#2a2a2a",
  colors: {
    // Brand colors, single shade only apart from aqua:
    // https://mantine.dev/colors-generator/?color=1AEFD6
    black: colorsTuple("#2a2a2a"),
    aqua,
    reef: colorsTuple("#DBFF91"),
    grapefruit: colorsTuple("#DD3310"),
    shamrock: colorsTuple("#039355"),

    // end brand colors,
    yellow,
    orange,
    red,
    green,
    pine,
    blue,
    grey,
  },
  primaryColor: "black",
});
